// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"797":"98d9ba15","983":"1c27a7b3"}[chunkId] + ".chunk.css";
};